module.exports = __webpack_public_path__ + "img/leztroy-crm-logo-mini.cca50740.png";